import { usePopup } from './PopupContext'
import './PopupArea.scss'
import Popup from './Popup'

const PopupArea = () => {
   const popup = usePopup()

  return (
    <>
      <div className='popup-area'>
        {popup?.popups.map((p, index) => (
          <Popup key={index} { ...p } />
        ))}
      </div>
    </>
  )
}
  
export default PopupArea